import axios from 'axios';
import { APIURL } from '../../hoc/AxiosSetting/axios';
import * as BiIcons from 'react-icons/bi';
import * as AiIcons from 'react-icons/ai';
import { Formik, Form, Field } from 'formik'
import React, { useState, useEffect } from 'react'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import swal from '@sweetalert/with-react';
import { useQueryClient } from 'react-query'
import { useHistory, useParams } from 'react-router'

function ListofLeadAuditrForm() {
    const { id } = useParams()
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState({
        _id: "",
    })
    const viewRoute = (item) =>{
        window.location.href ="/"+localStorage.getItem("role")+ '/viewofleadauditorform/' + item._id
    }
    const handleRoute = () => {
        window.location.href = "/"+localStorage.getItem("role")+"/leadauditorform"
    }
    const { data: clauseData, isDataLoading } = useQuery(
        'listClaouseData',
        () => Fetcher('get', '/api/competancy/get/competancydata/' + clauseData.data.response._id,{}))

    const editData =(item) =>{
        window.location.href = "/admin/leadauditorform/" + item._id
    }

    const { data: competancydataList, isLoading } = useQuery(
        'listnacecode',
        () => Fetcher('get', '/api/competancy/get/listofcompetancydata', {}))
   
    const mutationDelete = useMutation((params) => Fetcher('delete', '/api/competancy/delete/competancydata', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Competancy Data Deleted')
                queryClient.invalidateQueries('listnacecode');
            } else {
                var msg = 'Competancy Data - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Nace Code' + error)
        }
    })
    function deleteData(deleteId) {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    var jsonRequest = { id: deleteId }
                    mutationDelete.mutate(jsonRequest)
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })
    }
    useEffect(() => {
        if (clauseData && initialValues._id === "") {
           
            var tempData = clauseData.data.response
            console.log("tempData",tempData)
            setInitialValues(tempData)

        }
    }, [id && !isDataLoading && initialValues._id === ""])
    
    if (isLoading||isDataLoading) return <div>Loading</div>
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                // onSubmit={onSubmit}
            >
                {formik => <Form>
                    <div>
                    <div className="row">
                    <div className="col-sm-11" />
                        <div className="col-sm-1">
                            <button type="button" className="btn btn-success" onClick={() => handleRoute()}>Add</button>
                        </div> </div>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">

                                        <div className="col-sm-12">
                                            <div className="card-body">
                                            
                                                <div className="row">
                                                    <div className='col-sm-12'>

                                                        <div className="row">

                                                            <div className="col-lg-12 col-lg-offset-1">
                                                                <div class="card-body table-responsive">
                                                                    <table className="table table-bordered">
                                                                        <thead className="table-primary">
                                                                            <tr>
                                                                                <th scope="col" className="text-center" style={{ "width": "100px" }}>#</th>
                                                                                <th scope="col" className="text-center" style={{ "width": "120px" }}>Designation</th>
                                                                                <th scope="col" className="text-center" style={{ "width": "120px" }}>Nace Code(Main code)</th>
                                                                                <th scope="col" className="text-center" style={{ "width": "120px" }}>Nace Code(Sub code)</th>
                                                                                <th scope="col" className="text-center" style={{ "width": "120px" }}>Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {

                                                                                competancydataList && competancydataList.data.response && competancydataList.data.response.length > 0 ?
                                                                                    competancydataList.data.response.map((item, index) => {
                                                                                        return (
                                                                                            <tr key={index}>
                                                                                                <td className="text-center">{index + 1}</td>
                                                                                                <td>{item.designationName}</td>
                                                                                                <td>{item.nacemaincodeName}</td>
                                                                                                <td>{item.nacesubcodeName}</td>
                                                                                                <td className="text-center">
                                                                                                    <span style={{ "marginRight": "6%", "cursor": "pointer" }} onClick={() => editData(item)}><BiIcons.BiEdit /></span>
                                                                                                    <span style={{ "marginLeft": "6%", "cursor": "pointer" }} onClick={() => deleteData(item._id)}><AiIcons.AiOutlineDelete /></span>&nbsp;&nbsp;
                                                                                                    <span style={{ "marginLeft": "6%", "cursor": "pointer" }} onClick={()=>viewRoute(item)}><AiIcons.AiFillEye/></span>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    }) :
                                                                                    <>Please Add Data </>
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </Form>
                }
            </Formik>
        </div>
    )
}
export default ListofLeadAuditrForm